"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InnerShades = void 0;
var _presentationComponents = require("@ori/presentation-components");
var _react = require("react");
var _constants = require("../constants");
var _styles = require("../styles");
var _jsxRuntime = require("react/jsx-runtime");
const InnerShades = ({
  maxVisibleShadesCount,
  shades
}) => {
  // istanbul ignore next @preserve --not reachable as root component is not rendered when there are less than 2 shades

  const elements = (0, _react.useMemo)(() => shades.slice(0, maxVisibleShadesCount).map(shade => /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.Shade, {
    shade: {
      canBeSold: true,
      ...shade
    },
    size: _presentationComponents.ShadeSize.Small,
    testId: _constants.PRODUCT_BOX_SHADE_TEST_ID
  }, shade.productCode)), [maxVisibleShadesCount, shades]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [elements, shades.length > maxVisibleShadesCount ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.HiddenShadesCount, {
      children: ["+", shades.length - maxVisibleShadesCount]
    }) : null]
  });
};
exports.InnerShades = InnerShades;
//# sourceMappingURL=ShadesResponsive.js.map